import { Flex } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';
import SideBar from '../side-bar/SideBar';
import MainContent from '../main-content/MainContent';
import Navigation from '../navigation/Navigation';
import { LayoutProps } from './types';
import { RefsProvider, useLayoutRefs } from '../refs/refs';

const Wrapper: FC<PropsWithChildren<LayoutProps>> = ({
  children,
  navItems,
  onClickNavItem,
}) => {
  const refs = useLayoutRefs();
  return (
    <Flex
      w={'100vw'}
      height={'100vh'}
      flexDirection={'column'}
      ref={refs.layoutRef}
    >
      <SideBar w={'64px'}>
        <Navigation items={navItems} onClickNavItem={onClickNavItem} />
      </SideBar>
      <MainContent ml={'64px'}>{children}</MainContent>
    </Flex>
  );
};

export const MasterLayout: FC<PropsWithChildren<LayoutProps>> = (props) => {
  return (
    <RefsProvider>
      <Wrapper {...props} />
    </RefsProvider>
  );
};
